<template>
  <v-autocomplete
    v-model="selectedFound"
    :items="items"
    :loading="isLoading"
    :search-input.sync="searchString"
    hide-no-data
    hide-selected
    item-text="fullname"
    placeholder="Поиск"
    prepend-icon="search"
    append-icon=""
    return-object
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';
import STORE from '../../store/STORE';

const searchMethod = STORE.modules.globalSearch.actions.search;

export default {
  name: 'globalSearch',
  data: () => ({
    items: [],
    isLoading: false,
    selectedFound: null,
    searchString: null,
    _timerId: null,
  }),
  methods: {
    ...mapActions('globalSearch', [searchMethod]),

    async makeSearch(value) {
      this.items = [];
      this.isLoading = false;

      if (!value || value.length < 2) {
        return;
      }

      this.isLoading = true;
      try {
        this.items = await this[searchMethod](value);
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },

    makeSearchDebounced(value) {
      clearTimeout(this._timerId);

      this._timerId = setTimeout(() => {
        this.makeSearch(value)
      }, 300)
    }
  },
  watch: {
    selectedFound(value) {
      if (value) {
        this.$nextTick(() => {
          let id = value.id;
          this.selectedFound = null;
          this.searchString = '';
          window.open(`/trial/${id}` , '_blank');
        });

      }
    },

    async searchString(value) {
      this.makeSearchDebounced(value);
    }
  }
};
</script>
